/* ==========================================================================
   Cart drawer with gifts — extracted from the section's inline <script>.
   Loaded by sections/cart-drawer-gifts.liquid.

   The one Liquid value this used ({{ fb_prod.id }}) is now read from the
   #CartDrawer element's data-fallback-id attribute, which the section still
   renders with Liquid — so this file stays pure JS.
   ========================================================================== */
(() => {
  'use strict';

  const drawer     = document.getElementById('CartDrawer');
  const panel      = drawer.querySelector('.cart-drawer__panel');
  const toggleBtn  = document.getElementById('CartToggle');
  const closeEls   = drawer.querySelectorAll('[data-action="close"]');
  const totalEl    = document.getElementById('CartTotalPrice');
  const fill       = drawer.querySelector('.gift-progress__fill');
  const gifts      = Array.from(drawer.querySelectorAll('.gift-item'));
  const giftListEl = drawer.querySelector('.gift-list');
  // Сортируем вехи по порогу и в этом же порядке переставляем иконки —
  // корзина адаптируется к любым порогам (подарки + бесплатная доставка).
  // При равных порогах (доставка + подарок на $199) порядок внутри группы
  // фиксируем явно: доставка слева, подарок справа — иначе кружки менялись бы
  // местами в зависимости от порядка настроек в схеме.
  const isShippingEl = (el) => /shipping/i.test(el.dataset.title || '');
  gifts.sort((a, b) => {
    const diff = (+a.dataset.threshold) - (+b.dataset.threshold);
    if (diff !== 0) return diff;
    return (isShippingEl(a) ? 0 : 1) - (isShippingEl(b) ? 0 : 1);
  });
  if (giftListEl) gifts.forEach(g => giftListEl.appendChild(g));

  // Абсолютная шкала бара: вся полоска = $0 → SCALE_MAX (из data-scale-max,
  // в центах). Каждая веха стоит на позиции threshold/SCALE_MAX, поэтому
  // расстояния между кружками пропорциональны реальной разнице сумм,
  // а не раскиданы равномерно. Заполнение бара считается по той же шкале.
  const progressBox = drawer.querySelector('.gift-progress-container');
  const SCALE_MAX = Number(progressBox && progressBox.dataset.scaleMax) || 30000;
  // Позиция вехи в % от ширины бара (кламп 0..100 на случай порога > шкалы).
  const pctFor = (cents) => Math.max(0, Math.min(100, (cents / SCALE_MAX) * 100));
  // Раскладываем кружки абсолютно по их порогу. Вехи с ОДИНАКОВЫМ порогом
  // (напр. бесплатная доставка + подарок на $199) иначе встали бы в одну точку
  // и наложились друг на друга — поэтому такие группируем: центр группы стоит
  // на пороге, а кружки внутри разъезжаются симметрично на GROUP_STEP пикселей
  // и получают общую белую подложку (.gift-item--grouped), чтобы читаться как
  // одна веха с двумя бонусами, а не как два разных порога.
  // Шаг между центрами соседних кружков в группе (26px = 24px кружок + 2px
  // зазора, чтобы соседи не сливались в сплошную ленту). Кольцо .active
  // рисуется ВНУТРЬ кружка, поэтому зазор под него закладывать не нужно.
  const GROUP_STEP = 26;
  // Фактическая позиция каждой вехи в % ширины трека (после клампа и разъезда
  // внутри группы). Заполнение бара интерполируется по этим точкам, а не по
  // «чистой» доле threshold/SCALE_MAX — иначе на самом пороге полоса не
  // дотягивалась бы до сдвинутого кружка на пару пикселей.
  const giftPct = new Map();
  const layoutGifts = () => {
    // Подложки пересоздаются на каждой раскладке (resize / открытие корзины),
    // поэтому сначала убираем прошлые — иначе они копятся.
    if (giftListEl) {
      giftListEl.querySelectorAll('.gift-group-pill').forEach(p => p.remove());
    }

    const byThreshold = new Map();
    gifts.forEach(g => {
      const thr = +g.dataset.threshold;
      if (!byThreshold.has(thr)) byThreshold.set(thr, []);
      byThreshold.get(thr).push(g);
    });

    // Ширина трека нужна, чтобы кружки на краях шкалы (порог = 0 или = scale_max)
    // не вылезали за бар: центр группы поджимаем внутрь на её полуширину.
    const trackW = progressBox ? progressBox.getBoundingClientRect().width : 0;
    const CIRCLE = 24;

    byThreshold.forEach((group, thr) => {
      // Смещение i-го кружка от центра группы: для одного — 0, для двух — ∓13px.
      const mid = (group.length - 1) / 2;
      let basePct = pctFor(thr);
      if (trackW > 0) {
        // Полуширина группы в px → в % от трека, плюс радиус самого кружка.
        const halfGroup = mid * GROUP_STEP + CIRCLE / 2;
        const marginPct = (halfGroup / trackW) * 100;
        basePct = Math.max(marginPct, Math.min(100 - marginPct, basePct));
      }
      // Запоминаем фактическую позицию каждой вехи в % (с учётом клампа и
      // разъезда внутри группы) — по ней заполнение бара точно попадает в
      // кружок, когда сумма равна порогу.
      // Общая белая подложка под группой — отдельным элементом в начале списка,
      // а не псевдоэлементом кружка: псевдоэлемент рисуется в боксе своего
      // кружка и перекрывал соседей, срезая их кольца.
      if (group.length > 1) {
        const pill = document.createElement('li');
        pill.className = 'gift-group-pill';
        pill.setAttribute('aria-hidden', 'true');
        // Ширина = от левого края первого кружка до правого края последнего
        // плюс по 2px воздуха.
        pill.style.width = ((group.length - 1) * GROUP_STEP + CIRCLE + 4) + 'px';
        pill.style.left = basePct + '%';
        // Первым ребёнком — чтобы по порядку документа быть ниже всех кружков.
        giftListEl.insertBefore(pill, giftListEl.firstChild);
      }

      group.forEach((g, i) => {
        const offset = (i - mid) * GROUP_STEP;
        const offsetPct = trackW > 0 ? (offset / trackW) * 100 : 0;
        giftPct.set(g, basePct + offsetPct);
        g.style.left = basePct + '%';
        // translate(-50%) центрирует на точке, offset разводит внутри группы.
        g.style.setProperty('--gift-offset', offset.toFixed(1) + 'px');
        g.classList.toggle('gift-item--grouped', group.length > 1);
        g.classList.toggle('gift-item--group-first', group.length > 1 && i === 0);
        g.classList.toggle('gift-item--group-last', group.length > 1 && i === group.length - 1);
      });
    });
  };
  layoutGifts();
  // Центры иконок в % = ровно их пороговая позиция на шкале.
  const msgEl      = document.getElementById('GiftMessage');
  // Подстрочник: статичная строка про доставку, меняется на "free shipping
  // applied" после взятия порога доставки. Тексты — из настроек секции.
  const blurbEl       = document.getElementById('GiftBlurb');
  const BLURB_DEFAULT  = drawer.dataset.blurbDefault  || 'Air delivery across the US · Shipping calculated at checkout';
  const BLURB_SHIPPING = drawer.dataset.blurbShipping || 'Air delivery across the US · Free shipping applied';
  const itemsEl    = document.getElementById('CartItemsContainer');
  const recoBox    = document.getElementById('CartRecoBox');
  const recoList   = document.getElementById('CartRecoList');
  const recoTitle  = document.getElementById('CartRecoTitle');
  const refreshBtn = document.getElementById('RefreshRecoBtn');
  // Was `{{ fb_prod.id | default: 0 }}` inline — now from the data attribute.
  const FALLBACK_ID = Number(drawer.dataset.fallbackId) || 0;
  const SETS_URL = drawer.dataset.setsUrl || '/#sets';
  const discNotice = document.getElementById('CartDiscountNotice');
  const noteInput = document.getElementById('CartDrawerNote');
  const noteStatus = document.getElementById('CartDrawerNoteStatus');

  const giftVariants = gifts.map(g => +g.dataset.variant).filter(Boolean);
  const SKIP_KEY = 'skippedFreeGifts';
  let skippedGifts = [];
  let currentCart = null; // Сохраняем текущую корзину для refresh
  let noteSaveTimer = null;
  let noteDirty = false;
  // Первая отрисовка прогресса — без анимаций (см. renderProgress).
  let hasRenderedProgress = false;
  let allRewardsUnlocked = false;
  let rewardToastTimer = null;

  // Безопасная работа с localStorage
  try {
    skippedGifts = JSON.parse(localStorage.getItem(SKIP_KEY) || '[]');
  } catch (e) {
    skippedGifts = [];
  }

  const saveSkipped = () => {
    try {
      localStorage.setItem(SKIP_KEY, JSON.stringify(skippedGifts));
    } catch (e) {
      console.warn('Failed to save to localStorage');
    }
  };

  // Безопасное экранирование HTML
  const escapeHtml = (text) => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  const fetchCartRecos = async (cart, forceRefresh = false) => {
    try {
      const isEmptyCart = !cart.items?.length;
      const prodId = cart.items[0]?.product_id || FALLBACK_ID;
      let url = isEmptyCart
        ? '/collections/all/products.json?limit=6&sort_by=best-selling'
        : `/recommendations/products.json?limit=6&product_id=${prodId}`;

      // Добавляем случайный параметр для обновления кеша при refresh
      if (forceRefresh) {
        url += `&_refresh=${Date.now()}`;
      }

      const res = await fetch(url);
      if (!res.ok) return [];
      const data = await res.json();

      // Берем случайные 3 из 6 продуктов для разнообразия
      const products = (data.products || []).map(product => {
        if (!isEmptyCart) return product;

        // The collection products endpoint uses the Product JSON shape, while
        // the recommendations endpoint already returns featured_image/price.
        const firstVariant = product.variants?.[0];
        const price = Number.parseFloat(firstVariant?.price ?? product.price ?? '0');
        return {
          ...product,
          featured_image: product.featured_image || product.image?.src || product.images?.[0]?.src || '',
          price: Number.isFinite(price) ? Math.round(price * 100) : 0
        };
      });
      if (forceRefresh && products.length > 3) {
        // Перемешиваем массив и берем первые 3
        const shuffled = products.sort(() => 0.5 - Math.random());
        return shuffled.slice(0, 3);
      }

      return products.slice(0, 3);
    } catch {
      return [];
    }
  };

  let isCartUpdating = 0;
  let isGiftSyncing  = 0;
  let lastKnownTotal = 0;
  let isRefreshing = false;

  const $money = (cents) => {
    try {
      return window.Shopify?.formatMoney
        ? Shopify.formatMoney(cents, Shopify.money_format.replace(/\.00/, ''))
        : '$' + (cents / 100).toFixed(0);
    } catch {
      return '$' + (cents / 100).toFixed(0);
    }
  };

  const getCart = () => fetch('/cart.js').then(r => r.json());

  const setNoteStatus = (message) => {
    if (!noteStatus) return;
    noteStatus.textContent = message;
  };

  const saveCartNote = async () => {
    if (!noteInput) return;

    const note = noteInput.value;
    setNoteStatus('Saving...');

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
      });

      noteDirty = false;
      if (currentCart) currentCart.note = note;
      setNoteStatus('Saved');
      window.setTimeout(() => {
        if (!noteDirty) setNoteStatus('');
      }, 1800);
    } catch (err) {
      console.error('Cart note update error:', err);
      setNoteStatus('Could not save note');
      throw err;
    }
  };

  const renderCartNote = (cart) => {
    if (!noteInput || !cart) return;
    if (document.activeElement === noteInput || noteDirty) return;

    noteInput.value = cart.note || '';
    const removeButton = document.getElementById('CartDrawerNoteRemove');
    if (removeButton) removeButton.hidden = !noteInput.value.trim();
  };

  const refreshOverlay = () => {
    const busy = isCartUpdating + isGiftSyncing > 0;
    panel.classList.toggle('cart-drawer__panel--updating', busy);
  };

  function initRecoSlider() {
    const track = recoList;
    const prev  = drawer.querySelector('.cart-reco__btn--prev');
    const next  = drawer.querySelector('.cart-reco__btn--next');

    if (!track || track.children.length <= 1) {
      if (prev && next) {
        prev.style.display = next.style.display = 'none';
      }
      return;
    }

    if (prev && next) {
      prev.style.display = next.style.display = 'block';
    }

    const GAP = 8;
    const STEP = track.firstElementChild?.getBoundingClientRect().width + GAP || 200;

    // Native touch scrolling is not draggable with a desktop mouse. Give the
    // product strip the same drag behaviour for mouse, touch, and pen input.
    if (!track.dataset.dragReady) {
      let activePointer = null;
      let startX = 0;
      let startScrollLeft = 0;
      let didDrag = false;

      const endDrag = (event) => {
        if (activePointer !== event.pointerId) return;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        activePointer = null;
        track.classList.remove('is-dragging');
        if (didDrag) {
          track.dataset.suppressClick = 'true';
          window.setTimeout(() => { track.dataset.suppressClick = ''; }, 0);
        }
      };

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        // Buttons must always receive a normal tap/click. Without this guard a
        // tiny finger movement is treated as a drag and suppresses the add
        // action below.
        if (event.target.closest('button, a, input, textarea, select')) return;
        activePointer = event.pointerId;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        didDrag = false;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', (event) => {
        if (activePointer !== event.pointerId) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 3) didDrag = true;
        track.scrollLeft = startScrollLeft - delta;
      });
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', (event) => {
        if (track.dataset.suppressClick !== 'true') return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
      track.dataset.dragReady = 'true';
    }

    function toggleState() {
      if (!prev || !next) return;
      const pos = Math.round(track.scrollLeft);
      const max = Math.round(track.scrollWidth - track.clientWidth);
      prev.disabled = pos <= 4;
      next.disabled = pos >= max - 4;
    }

    toggleState();
    requestAnimationFrame(toggleState);

    if (prev) prev.onclick = () => { if (!prev.disabled) track.scrollBy({left:-STEP,behavior:'smooth'}); };
    if (next) next.onclick = () => { if (!next.disabled) track.scrollBy({left: STEP,behavior:'smooth'}); };

    track.addEventListener('scroll', () => requestAnimationFrame(toggleState));
  }

  async function syncGifts(cart) {
    if (isGiftSyncing) return false;
    isGiftSyncing++;
    refreshOverlay();

    try {
      const updates = {};
      const toAdd = [];
      const current = cart.items.filter(i => giftVariants.includes(i.variant_id));

      gifts.forEach(giftEl => {
        const v_id = Number(giftEl.dataset.variant);
        if (!v_id) return;

        const threshold = Number(giftEl.dataset.threshold);
        const shouldHave = cart.total_price >= threshold;
        const inCartItem = current.find(i => i.variant_id === v_id);
        const skipped = skippedGifts.includes(v_id);

        if (shouldHave && !inCartItem && !skipped) {
          toAdd.push({
            id: v_id,
            quantity: 1,
            properties: { _free_gift: true }
          });
        }

        if (!shouldHave && inCartItem) {
          updates[inCartItem.key] = 0;
        }

        if (!shouldHave && skipped) {
          skippedGifts = skippedGifts.filter(id => id !== v_id);
          saveSkipped();
        }
      });

      if (Object.keys(updates).length) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }

      if (toAdd.length) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: toAdd })
        });
      }

      return Boolean(Object.keys(updates).length || toAdd.length);

    } catch (err) {
      console.error('Gift sync error:', err);
      return false;
    } finally {
      isGiftSyncing--;
      refreshOverlay();
    }
  }

// Собирает список бонусов одного порога в человеческую фразу:
//   [доставка]        → "free shipping"
//   [доставка, сыр]   → "free shipping and a free gift"
//   [сыр, морковь]    → "2 free gifts"
// Подарки НЕ называем по имени: названия товаров длинные и рвут заголовок на
// две строки. Что именно за подарок — видно по фото на самом кружке.
function describeTier(tierGifts) {
  const shipping = tierGifts.filter(g => /shipping/i.test(g.dataset.title || ''));
  const products = tierGifts.filter(g => !/shipping/i.test(g.dataset.title || ''));

  // Строчные, не капслок: в US-рознице капс в теле страницы читается как
  // крикливая реклама и бьёт по доверию к премиальному продукту.
  const parts = [];
  if (shipping.length) parts.push('free shipping');
  if (products.length === 1) parts.push('a free gift');
  else if (products.length > 1) parts.push(`${products.length} free gifts`);

  return parts.join(' and ');
}

// Заполнение бара в %. Кусочно-линейная интерполяция по фактическим позициям
// вех: между $0 и первой вехой, между соседними вехами, и после последней — до
// края шкалы. Благодаря этому на сумме РОВНО в порог полоса приходит точно в
// центр кружка, даже если тот сдвинут клампом или разъездом внутри группы.
function fillPctFor(total) {
  // Опорные точки: (сумма в центах → позиция в %), по возрастанию.
  const pts = [[0, 0]];
  const seen = new Set();
  gifts.forEach(g => {
    const thr = +g.dataset.threshold;
    if (seen.has(thr)) return;      // у группы одна общая точка
    seen.add(thr);
    // Для группы берём центр группы: среднее фактических позиций её кружков.
    const inTier = gifts.filter(x => +x.dataset.threshold === thr);
    const avg = inTier.reduce((s, x) => s + (giftPct.get(x) ?? pctFor(thr)), 0) / inTier.length;
    pts.push([thr, avg]);
  });
  pts.push([SCALE_MAX, 100]);
  pts.sort((a, b) => a[0] - b[0]);

  if (total <= 0) return 0;
  for (let i = 1; i < pts.length; i++) {
    const [c0, p0] = pts[i - 1];
    const [c1, p1] = pts[i];
    if (total <= c1) {
      if (c1 === c0) return p1;
      return p0 + ((total - c0) / (c1 - c0)) * (p1 - p0);
    }
  }
  return 100;
}

function celebrateAllRewards() {
  const shipping = drawer.querySelector('.cart-shipping');
  const card = drawer.querySelector('.cart-shipping__card');
  if (!shipping || !card) return;

  clearTimeout(rewardToastTimer);
  card.classList.remove('cart-shipping__card--celebrating');
  void card.offsetWidth;
  card.classList.add('cart-shipping__card--celebrating');

  rewardToastTimer = window.setTimeout(() => {
    card.classList.remove('cart-shipping__card--celebrating');
    if (allRewardsUnlocked) shipping.classList.add('cart-shipping--dismissed');
  }, 1200);
}

function resetAllRewardsState() {
  allRewardsUnlocked = false;
  clearTimeout(rewardToastTimer);
  drawer.querySelector('.cart-shipping')?.classList.remove('cart-shipping--dismissed');
  drawer.querySelector('.cart-shipping__card')?.classList.remove('cart-shipping__card--celebrating');
}

function renderProgress(total) {
  // Заполнение — по фактическим позициям вех (см. fillPctFor), чтобы полоса
  // попадала ровно в кружок на пороге.
  fill.style.width = Math.max(0, Math.min(100, fillPctFor(total))) + '%';

  // Состояния вех + разовый "поп" на тех, что взяли ИМЕННО сейчас.
  // На ПЕРВОЙ отрисовке анимацию не играем: иначе всё уже взятое дёргается
  // при каждом открытии корзины — награда должна отмечать переход, а не факт.
  const firstRender = !hasRenderedProgress;
  hasRenderedProgress = true;
  gifts.forEach(g => {
    const reached = total >= +g.dataset.threshold;
    const wasReached = g.classList.contains('active');
    g.classList.toggle('active', reached);
    if (reached && !wasReached && !firstRender) {
      g.classList.remove('just-unlocked');
      void g.offsetWidth;
      g.classList.add('just-unlocked');
    }
  });

  // aria: озвучиваем прогресс скринридеру в долларах.
  if (progressBox) progressBox.setAttribute('aria-valuenow', (total / 100).toFixed(2));

  // Заголовок — ВСЕГДА про ближайший непройденный порог, одной строкой.
  // Шкала бара при этом не перерисовывается: все вехи видны всегда, поэтому
  // после взятия $199 полоса продолжает расти к $250, а не сбрасывается в 0.
  const nextThreshold = gifts.reduce((min, g) => {
    const thr = +g.dataset.threshold;
    return total < thr && (min === null || thr < min) ? thr : min;
  }, null);

  // Достигнута ли бесплатная доставка — от этого зависит подстрочник.
  const shippingGift = gifts.find(g => /shipping/i.test(g.dataset.title || ''));
  const shippingReached = shippingGift ? total >= +shippingGift.dataset.threshold : false;
  if (blurbEl) {
    // Когда всё собрано, подстрочник перечисляет ЧТО именно получено —
    // заголовок в этом состоянии короткий и состава не называет.
    // Иначе — обычная строка про доставку из настроек секции.
    // "included" подтверждает, что бонусы УЖЕ в заказе, а не «положены вам» —
    // снимает вопрос «точно применилось?» прямо перед оплатой.
    const won = describeTier(gifts);
    blurbEl.textContent = nextThreshold === null
      ? `${won.charAt(0).toUpperCase()}${won.slice(1)} included`
      : (shippingReached ? BLURB_SHIPPING : BLURB_DEFAULT);
  }

  if (nextThreshold !== null) {
    const tierGifts = gifts.filter(g => +g.dataset.threshold === nextThreshold);
    const delta = ((nextThreshold - total) / 100).toFixed(2).replace(/\.00$/, '');
    // "$134 away from free shipping and a free gift" — сумма-остаток жирная,
    // это то, что сканируют глазами.
    msgEl.innerHTML = `You’re <b>$${delta}</b> away from <b>${describeTier(tierGifts)}</b>`;

    // Лёгкий shake на иконках ближайшей цели — подсказка, куда смотреть.
    // Только при реальном изменении корзины, не при первом открытии.
    if (!firstRender) {
      tierGifts.forEach(g => {
        // Внутри вехи либо фото товара, либо инлайн-глиф доставки.
        const icon = g.querySelector('img, .gift-item__glyph');
        if (!icon) return;
        icon.classList.remove('shake');
        void icon.offsetWidth;
        icon.classList.add('shake');
      });
    }
  } else {
    // Всё собрано: короткий заголовок в ОДНУ строку — длинное перечисление
    // здесь ломалось на две и выглядело тяжело. Состав уезжает в подстрочник,
    // где читается спокойно и не спорит с заголовком.
    // "You're all set" — стандартная американская формула завершённости.
    // Без эмодзи: в момент готовности платить праздник отвлекает от Checkout.
    msgEl.textContent = 'You’re all set';
  }

  // Всё собрано — карточке больше нечего мотивировать, поэтому она ужимается
  // (меньше отступы) и уступает место кнопке Checkout.
  const card = drawer.querySelector('.cart-shipping__card');
  if (card) card.classList.toggle('cart-shipping__card--complete', nextThreshold === null);

  if (nextThreshold !== null) {
    resetAllRewardsState();
  } else if (firstRender) {
    // An already-complete cart should open cleanly; celebrate only a new unlock.
    allRewardsUnlocked = true;
    drawer.querySelector('.cart-shipping')?.classList.add('cart-shipping--dismissed');
  } else if (!allRewardsUnlocked) {
    allRewardsUnlocked = true;
    celebrateAllRewards();
  }
}

  // Empty-state markup per the design: 64px bag icon, "Your cart is empty",
  // and a black "Start shopping" button that closes the drawer and goes to
  // the catalog. Used in both empty branches below.
  const EMPTY_CART_HTML = `
    <div class="cart-empty">
      <span class="cart-empty__icon" aria-hidden="true">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.12" d="M43.2772 58.6667C48.151 58.6667 50.5879 58.6667 52.3786 57.6901C53.9517 56.8322 55.1912 55.471 55.8985 53.8247C56.7037 51.9507 56.4762 49.5244 56.0213 44.6719L54.4213 27.6052C54.0372 23.5076 53.8451 21.4588 52.9236 19.9098C52.112 18.5456 50.9129 17.4536 49.4789 16.7729C47.8506 16 45.7928 16 41.6772 16L22.3228 16C18.2072 16 16.1494 16 14.5211 16.7729C13.0871 17.4536 11.888 18.5456 11.0764 19.9098C10.1549 21.4588 9.96282 23.5076 9.57866 27.6052L7.97866 44.6719C7.52374 49.5244 7.29627 51.9507 8.10145 53.8247C8.80878 55.471 10.0483 56.8322 11.6214 57.6901C13.4121 58.6667 15.849 58.6667 20.7228 58.6667H43.2772Z" fill="#595959"/>
          <path d="M42.6667 24V16C42.6667 10.109 37.891 5.33333 32 5.33333C26.109 5.33333 21.3333 10.109 21.3333 16V24M9.57866 27.6052L7.97866 44.6719C7.52374 49.5244 7.29627 51.9507 8.10145 53.8247C8.80878 55.471 10.0483 56.8322 11.6214 57.6901C13.4121 58.6667 15.849 58.6667 20.7228 58.6667H43.2772C48.151 58.6667 50.5879 58.6667 52.3786 57.6901C53.9517 56.8322 55.1912 55.471 55.8985 53.8247C56.7037 51.9507 56.4762 49.5244 56.0213 44.6719L54.4213 27.6052C54.0372 23.5076 53.8451 21.4588 52.9236 19.9098C52.112 18.5456 50.9129 17.4536 49.4789 16.7729C47.8506 16 45.7928 16 41.6772 16L22.3228 16C18.2072 16 16.1494 16 14.5211 16.7729C13.0871 17.4536 11.888 18.5456 11.0764 19.9098C10.1549 21.4588 9.96282 23.5076 9.57866 27.6052Z" stroke="#595959" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <p class="cart-empty__title">Your cart is empty</p>
      <a href="${SETS_URL}" class="cart-empty__btn">Start shopping</a>
    </div>`;

  // The empty drawer keeps the marketing shipping/gifts card and the product
  // recommendations. Cart-only controls and the checkout bar are hidden via
  // the state class below.
  const shippingBox = drawer.querySelector('.cart-shipping');
  const setEmptyCartState = (isEmpty) => {
    drawer.classList.toggle('cart-drawer--empty', isEmpty);
    if (shippingBox) shippingBox.hidden = false;
    if (recoTitle) {
      recoTitle.textContent = isEmpty ? 'TRENDING' : 'GOES WELL WITH YOUR ORDER';
    }
  };

  function renderItems(cart) {
    if (!cart?.items || !cart.items.length) {
      itemsEl.innerHTML = EMPTY_CART_HTML;
      setEmptyCartState(true);
      return;
    }
    setEmptyCartState(false);

    const shippingReward = gifts.find(isShippingEl);
    const hasFreeShipping = shippingReward &&
      cart.total_price >= Number(shippingReward.dataset.threshold || 0);
    const shippingRow = hasFreeShipping ? `
      <div class="cart-item cart-item--shipping" data-benefit="free-shipping">
        <span class="cart-item__shipping-icon" aria-hidden="true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.7214 2.00624C18.7505 0.943337 20.451 0.929586 21.4973 1.97571C22.5148 2.99321 22.5337 4.63692 21.5402 5.67756L18.5762 8.78133C18.3439 9.0246 18.2277 9.14624 18.1562 9.2887C18.0928 9.41515 18.055 9.55287 18.0451 9.69378C18.0341 9.85281 18.0719 10.0167 18.1476 10.3444L19.9907 18.3312C20.0682 18.6676 20.107 18.8359 20.0945 18.9987C20.0833 19.1427 20.0431 19.283 19.9763 19.4111C19.9007 19.5557 19.7787 19.6778 19.5346 19.9218L19.1391 20.3173C18.4925 20.964 18.1691 21.2873 17.8381 21.3459C17.5491 21.397 17.252 21.3268 17.0164 21.1519C16.7468 20.9517 16.6023 20.518 16.3134 19.651L14.1745 13.234L10.6158 16.7927C10.4033 17.0052 10.297 17.1115 10.2259 17.2366C10.1628 17.3476 10.1202 17.469 10.1002 17.5951C10.0775 17.7375 10.0941 17.8872 10.1273 18.1865L10.323 19.9482C10.3562 20.2475 10.3728 20.3972 10.3501 20.5396C10.3301 20.6657 10.2875 20.7871 10.2244 20.8981C10.1533 21.0232 10.047 21.1295 9.83447 21.342L9.62431 21.5522C9.1208 22.0557 8.86905 22.3075 8.58925 22.3804C8.34385 22.4443 8.08364 22.4186 7.85542 22.3078C7.59531 22.1813 7.39776 21.8849 7.00264 21.2922L5.3338 18.7889C5.26323 18.683 5.22794 18.63 5.18698 18.582C5.15059 18.5392 5.11087 18.4995 5.0681 18.4631C5.02012 18.4221 4.96714 18.3868 4.86118 18.3162L2.35789 16.6474C1.76524 16.2523 1.46891 16.0547 1.34239 15.7946C1.23152 15.5664 1.20581 15.3062 1.26974 15.0608C1.34263 14.781 1.59439 14.5293 2.0979 14.0258L2.30806 13.8156C2.52058 13.6031 2.62684 13.4968 2.75199 13.4257C2.863 13.3626 2.98439 13.32 3.11048 13.3C3.25288 13.2773 3.40256 13.2939 3.70193 13.3271L5.46363 13.5228C5.763 13.5561 5.91269 13.5727 6.05508 13.55C6.18117 13.53 6.30256 13.4874 6.41357 13.4243C6.53872 13.3532 6.64498 13.2469 6.8575 13.0344L10.4162 9.47567L3.99918 7.3368C3.13214 7.04778 2.69862 6.90327 2.49835 6.63365C2.32342 6.39808 2.25326 6.10094 2.30432 5.81195C2.36286 5.48095 2.68619 5.15762 3.33285 4.51095L3.72834 4.11546C3.97242 3.87138 4.09446 3.74934 4.23909 3.67372C4.36716 3.60676 4.50743 3.56654 4.65144 3.55546C4.8142 3.54293 4.98246 3.58174 5.31899 3.65936L13.2754 5.49395C13.6061 5.57021 13.7715 5.60834 13.9311 5.59699C14.0852 5.58602 14.2351 5.54172 14.3704 5.46714C14.5106 5.38988 14.6286 5.26801 14.8646 5.02427L17.7214 2.00624Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </span>
        <div class="cart-item__info">
          <p class="cart-item__title">Free shipping</p>
          <span class="free-gift">Your order now ships free</span>
        </div>
      </div>` : '';
    const orderedItems = [...cart.items].sort((a, b) =>
      Number(giftVariants.includes(b.variant_id)) - Number(giftVariants.includes(a.variant_id))
    );

    itemsEl.innerHTML = shippingRow + orderedItems.map(it => {
      const isGift = giftVariants.includes(it.variant_id);
      const safeTitle = escapeHtml(it.product_title);
      const safeImage = escapeHtml(it.image || '');

      // The chosen size, as a chip beside the name. /cart.js leaves
      // variant_title null on single-variant products, and Shopify's synthetic
      // "Default Title" is not a size anyone chose, so both are dropped.
      //
      // A chip inside the title element rather than a line of its own: the
      // .cart-item grid is two fixed rows adding up to the 72px image, so a
      // third row would push every line taller. The name truncates and the
      // chip does not — when two lines are the same product in two sizes, the
      // chip is the half that tells them apart.
      const variantTitle =
        it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      // The space between the two spans is deliberate. .cart-item__title is a
      // flex container, and a whitespace-only text run between flex items is
      // not rendered — so with the stylesheet in place the 6px gap is the only
      // separation. Without it (an older cart-drawer-gifts.css still on the
      // store) the spans fall back to inline and the space keeps the size from
      // welding itself onto the product name.
      const titleInner =
        `<span class="cart-item__name">${safeTitle}</span>` +
        (variantTitle ? ` <span class="cart-item__variant">${escapeHtml(variantTitle)}</span>` : '');

      return `
        <div class="cart-item" data-id="${it.key}" data-variant="${it.variant_id}" data-quantity="${it.quantity}" ${isGift ? 'data-gift="1"' : ''}>
          <img class="cart-item__img" src="${safeImage}" alt="${safeTitle}" loading="lazy">
          <div class="cart-item__info">
            ${isGift
              ? `<p class="cart-item__title">${titleInner}</p>`
              : `<a href="${it.url}" class="cart-item__title">${titleInner}</a>`}
            <div class="cart-item__qty">
              ${isGift
                ? '<span class="free-gift">Free gift</span>'
                : `<button class="qty-btn js-minus" type="button" aria-label="Decrease quantity"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0.850098 6.68343H12.5168" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg></button>
                   <span class="qty-val">${it.quantity}</span>
                   <button class="qty-btn js-plus" type="button" aria-label="Increase quantity"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6.68343 0.850098V12.5168M0.850098 6.68343H12.5168" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`}
            </div>
          </div>
          <div class="cart-item__price">
            <button class="js-remove" type="button" aria-label="Remove item"><svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11.6834 4.18343V3.51676C11.6834 2.58334 11.6834 2.11663 11.5018 1.76011C11.342 1.44651 11.087 1.19154 10.7734 1.03175C10.4169 0.850098 9.95018 0.850098 9.01676 0.850098H7.68343C6.75001 0.850098 6.2833 0.850098 5.92678 1.03175C5.61318 1.19154 5.35821 1.44651 5.19842 1.76011C5.01676 2.11663 5.01676 2.58334 5.01676 3.51676V4.18343M6.68343 8.76676V12.9334M10.0168 8.76676V12.9334M0.850098 4.18343H15.8501M14.1834 4.18343V13.5168C14.1834 14.9169 14.1834 15.617 13.9109 16.1517C13.6713 16.6221 13.2888 17.0046 12.8184 17.2443C12.2836 17.5168 11.5836 17.5168 10.1834 17.5168H6.51676C5.11663 17.5168 4.41657 17.5168 3.88179 17.2443C3.41138 17.0046 3.02893 16.6221 2.78925 16.1517C2.51676 15.617 2.51676 14.9169 2.51676 13.5168V4.18343" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
            ${isGift ? '' : `<span class="cur-price">${$money(it.price)}</span>`}
          </div>
        </div>`;
    }).join('') || EMPTY_CART_HTML;
  }

  async function renderRecos(cart, forceRefresh = false) {
    try {
      // Показываем состояние загрузки только при refresh
      if (forceRefresh && refreshBtn) {
        refreshBtn.classList.add('loading');
        refreshBtn.disabled = true;
      }

      const products = await fetchCartRecos(cart, forceRefresh);
      if (!products.length) {
        recoBox.style.display = 'none';
        return;
      }

      recoBox.style.display = '';
      recoList.innerHTML = products.map(p => {
        const safeTitle = escapeHtml(p.title);
        const safeImage = escapeHtml(p.featured_image || '');

        // A product with more than one size has no "the" variant to add. The +
        // used to take variants[0] regardless, so a recommendation could put a
        // 5 lb side of trout in the cart from a single tap. Those link to the
        // product page instead, where the size is an actual choice.
        const plusGlyph = `<svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6.68343 0.850098V12.5168M0.850098 6.68343H12.5168" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
        const variantCount = Array.isArray(p.variants) ? p.variants.length : 0;
        // Exactly one variant is the only case with a variant to add. Zero
        // (a malformed payload) falls through to the link rather than reading
        // variants[0].id off nothing, which is what used to throw here and
        // wipe out the whole recommendations row.
        const soleVariantId = variantCount === 1 ? p.variants[0].id : null;
        const action = soleVariantId
          ? `<button class="cart-reco__add" data-id="${soleVariantId}" type="button" aria-label="Add ${safeTitle}">${plusGlyph}</button>`
          : `<a class="cart-reco__add" href="${escapeHtml(p.url || '/')}" aria-label="Choose a size for ${safeTitle}">${plusGlyph}</a>`;

        return `
          <li class="cart-reco__card">
            <div class="cart-reco__top">
              <img src="${safeImage}" alt="${safeTitle}" loading="lazy">
              ${action}
            </div>
            <div class="cart-reco__bottom">
              <p class="title">${safeTitle}</p>
              <p class="price">${variantCount > 1 ? `from ${$money(p.price_min ?? p.price)}` : $money(p.price)}</p>
            </div>
          </li>
        `;
      }).join('');

      initRecoSlider();
    } catch (error) {
      console.error('Error rendering recommendations:', error);
      recoBox.style.display = 'none';
    } finally {
      if (forceRefresh && refreshBtn) {
        refreshBtn.classList.remove('loading');
        refreshBtn.disabled = false;
      }
    }
  }

  async function updateCart(itemKey, quantity) {
    if (isCartUpdating) return;
    isCartUpdating++;
    refreshOverlay();

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity })
      });
      const cart = res.ok ? await res.json() : await getCart();
      return await handleCartUpdate(cart);

    } catch (err) {
      console.error('Cart update error:', err);
      return await handleCartUpdate(await getCart());
    } finally {
      isCartUpdating--;
      refreshOverlay();
    }
  }

  // Промокод
  const discError = document.getElementById('CartDiscountError');
  const discInput = document.getElementById('CartDiscountInput');
  const discApply = document.getElementById('CartDiscountApply');
  const suggestedApply = document.getElementById('CartDiscountSuggestedApply');
  const appliedCodesEl = document.getElementById('CartDiscountAppliedCodes');
  const discountToggle = document.getElementById('CartDiscountToggle');
  const discountContainer = drawer.querySelector('.cart-discount__container');
  const suggestedCode = drawer.querySelector('.cart-discount')?.dataset.suggestedCode || '';
  const checkoutBtn = document.getElementById('CartCheckoutBtn');
  const discList = document.getElementById('CartDiscountCodes');
  const noteRemove = document.getElementById('CartDrawerNoteRemove');
  const noteDetails = drawer.querySelector('.cart-note-drawer');
  const noteSummary = noteDetails?.querySelector('summary');

  if (noteRemove && noteInput) noteRemove.hidden = !noteInput.value.trim();

  if (noteInput) {
    noteInput.addEventListener('input', () => {
      noteDirty = true;
      if (noteRemove) noteRemove.hidden = !noteInput.value.trim();
      setNoteStatus('');
      clearTimeout(noteSaveTimer);
      noteSaveTimer = window.setTimeout(() => {
        saveCartNote().catch(() => {});
      }, 700);
    });

    noteInput.addEventListener('blur', () => {
      window.setTimeout(() => {
        const hasText = noteInput.value.trim().length > 0;
        const isStillFocused = noteDetails?.contains(document.activeElement);
        if (noteDetails?.open && !hasText && !isStillFocused) noteDetails.open = false;
      }, 0);
    });
  }

  if (noteDetails && noteInput) {
    noteDetails.addEventListener('toggle', () => {
      if (noteDetails.open && !noteInput.value.trim()) {
        window.requestAnimationFrame(() => noteInput.focus());
      }
    });
  }

  if (noteRemove && noteInput && noteDetails) {
    noteRemove.addEventListener('click', () => {
      noteInput.value = '';
      noteDirty = true;
      noteRemove.hidden = true;
      clearTimeout(noteSaveTimer);
      noteDetails.open = false;
      setNoteStatus('');
      noteSummary?.focus();

      saveCartNote().catch(() => {
        setNoteStatus('Could not remove note. Please try again.');
      });
    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async (event) => {
      event.preventDefault();
      clearTimeout(noteSaveTimer);

      try {
        if (noteDirty) {
          await saveCartNote();
        }
      } catch (err) {
        return;
      }

      window.location.href = checkoutBtn.href;
    });
  }

  if (discInput && discApply) {
    discInput.addEventListener('input', () => {
      const on = discInput.value.trim().length > 0;
      discApply.classList.toggle('enabled', on);
      discApply.disabled = !on;
      // The error belongs to the previous value. Once it is cleared there is
      // nothing left to correct, so the empty field may collapse on blur.
      if (!on) showError('');
    });
  }

  const hideEmptyDiscountInput = () => {
    window.setTimeout(() => {
      const hasText = discInput?.value.trim().length > 0;
      const hasError = discError && !discError.classList.contains('hidden');
      const isStillFocused = discountContainer?.contains(document.activeElement);
      if (!discountContainer || discountContainer.hidden || hasText || hasError || isStillFocused) return;

      discountContainer.hidden = true;
      if (discountToggle) discountToggle.hidden = false;
    }, 0);
  };

  if (discountToggle && discountContainer && discInput) {
    discountToggle.addEventListener('click', () => {
      discountContainer.hidden = false;
      discountToggle.hidden = true;
      discInput.focus();
    });

    discInput.addEventListener('blur', hideEmptyDiscountInput);
  }

  const getAppliedCodes = (cart) => {
    // A code can be present in discount_codes while being invalid or
    // ineligible for the current cart. Only applicable:true means applied.
    const fromDiscountCodes = (cart.discount_codes || [])
      .filter(discount => discount?.applicable === true)
      .map(discount => discount.code);

    // These collections contain actual allocations, so they are safe
    // fallbacks for carts created before discount_codes became available.
    const fromCartAllocations = (cart.cart_level_discount_applications || [])
      .filter(application => application.type === 'discount_code')
      .map(application => application.title);
    const fromShippingAllocations = (cart.shipping_discount_applications || [])
      .filter(application => application.type === 'discount_code')
      .map(application => application.code || application.title);

    const normalizedCodes = new Map();
    [
      ...fromDiscountCodes,
      ...fromCartAllocations,
      ...fromShippingAllocations
    ].forEach(rawCode => {
      const code = typeof rawCode === 'string' ? rawCode.trim() : '';
      if (!code) return;

      const normalized = code.toLowerCase();
      if (!normalizedCodes.has(normalized)) normalizedCodes.set(normalized, code);
    });

    return Array.from(normalizedCodes.values());
  };

  const updateCartDiscounts = async (codes) => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: codes.join(',') })
    });
    const cart = await response.json().catch(() => null);

    if (!response.ok || !cart) {
      const message = cart?.description || cart?.message || 'Could not update promo codes';
      throw new Error(message);
    }

    return cart;
  };

  const promoTagIcon = `<svg class="cart-discount__icon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6.8501 6.8501H6.8601M0.850098 4.0501L0.850098 8.52461C0.850098 9.01379 0.850098 9.25838 0.905358 9.48856C0.954351 9.69263 1.03516 9.88772 1.14482 10.0667C1.2685 10.2685 1.44145 10.4415 1.78735 10.7874L9.45598 18.456C10.644 19.644 11.2381 20.2381 11.923 20.4606C12.5256 20.6564 13.1746 20.6564 13.7771 20.4606C14.4621 20.2381 15.0562 19.644 16.2442 18.456L18.456 16.2442C19.644 15.0562 20.2381 14.4621 20.4606 13.7771C20.6564 13.1746 20.6564 12.5256 20.4606 11.923C20.2381 11.2381 19.644 10.644 18.456 9.45598L10.7874 1.78736C10.4415 1.44145 10.2685 1.2685 10.0667 1.14482C9.88772 1.03516 9.69263 0.954351 9.48856 0.905358C9.25838 0.850098 9.01379 0.850098 8.52461 0.850098L4.0501 0.850098C2.92999 0.850098 2.36994 0.850098 1.94212 1.06808C1.56579 1.25983 1.25983 1.56579 1.06809 1.94212C0.850098 2.36994 0.850098 2.92999 0.850098 4.0501ZM7.3501 6.8501C7.3501 7.12624 7.12624 7.3501 6.8501 7.3501C6.57396 7.3501 6.3501 7.12624 6.3501 6.8501C6.3501 6.57395 6.57396 6.3501 6.8501 6.3501C7.12624 6.3501 7.3501 6.57395 7.3501 6.8501Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const appliedIcon = `<svg class="cart-discount__applied-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M4.75 8.1 6.85 10.2 11.35 5.7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  const renderPromoState = (codes) => {
    const suggestedIsApplied = !!suggestedCode && codes.some(code =>
      code.toLowerCase() === suggestedCode.toLowerCase()
    );

    if (suggestedApply) {
      suggestedApply.classList.toggle('is-applied', suggestedIsApplied);
      suggestedApply.disabled = suggestedIsApplied;
      suggestedApply.innerHTML = suggestedIsApplied ? `${appliedIcon}<span>Applied</span>` : 'Apply';
    }

    if (appliedCodesEl) {
      appliedCodesEl.innerHTML = codes
        .filter(code => code.toLowerCase() !== suggestedCode.toLowerCase())
        .map(code => `<div class="cart-discount__applied-row">${promoTagIcon}<span class="cart-discount__applied-code">${escapeHtml(code)}</span><span class="cart-discount__applied-status">${appliedIcon}<span>Applied</span></span></div>`)
        .join('');
    }
  };

  const showError = (msg) => {
    if (!discError) return;
    discError.textContent = msg;
    discError.classList.toggle('hidden', !msg);
  };

  const applyDiscount = async () => {
    const code = discInput.value.trim();
    if (!code) return;

    discApply.classList.add('loading');
    discApply.disabled = true;
    showError('');

    try {
      const cartBefore = await getCart();
      const codesBefore = getAppliedCodes(cartBefore);

      if (codesBefore.some(c => c.toLowerCase() === code.toLowerCase())) {
        showError('This promo code is already applied');
        return;
      }

      const cartAfter = await updateCartDiscounts([...codesBefore, code]);
      const validCode = getAppliedCodes(cartAfter)
        .some(appliedCode => appliedCode.toLowerCase() === code.toLowerCase());

      if (!validCode) {
        showError('This code is invalid or not available for your cart.');

        // Shopify can keep an inapplicable attempt in discount_codes.
        // Restore only the codes that were valid before this request.
        try {
          const restoredCart = await updateCartDiscounts(codesBefore);
          await handleCartUpdate(restoredCart);
        } catch (rollbackError) {
          console.error('Error restoring promo codes:', rollbackError);
          await handleCartUpdate(cartBefore);
        }
        return;
      }

      await handleCartUpdate(cartAfter);
      discInput.value = '';
      if (discountContainer) discountContainer.hidden = true;
      if (discountToggle) discountToggle.hidden = false;

    } catch (err) {
      console.error('Error applying discount code:', err);
      showError('Error applying promo code. Please try again.');
    } finally {
      discApply.classList.remove('loading');
      const hasCode = discInput.value.trim().length > 0;
      discApply.classList.toggle('enabled', hasCode);
      discApply.disabled = !hasCode;
    }
  };

  if (discApply) {
    discApply.addEventListener('click', applyDiscount);
  }
  if (suggestedApply && discInput) {
    suggestedApply.addEventListener('click', () => {
      discInput.value = suggestedCode;
      discInput.dispatchEvent(new Event('input'));
      applyDiscount();
    });
  }
  if (discInput) {
    discInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !discApply.disabled) {
        e.preventDefault();
        applyDiscount();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        discInput.value = '';
        discInput.dispatchEvent(new Event('input'));
        showError('');
        if (discountContainer) discountContainer.hidden = true;
        if (discountToggle) {
          discountToggle.hidden = false;
          discountToggle.focus();
        }
      }
    });
  }

  const renderTotals = (cart) => {
    if (!cart) return;

    const codes = getAppliedCodes(cart);
    renderPromoState(codes);
    if (discNotice) {
  if (codes.length >= 2) {
    discNotice.innerHTML = 'Heads up: you entered multiple promo codes. Some discounts may not stack. <b>On the next step (checkout)</b> please confirm that all intended discounts are applied.';
    discNotice.classList.remove('hidden');
  } else {
    discNotice.textContent = '';
    discNotice.classList.add('hidden');
  }
}
    if (discList) {
      discList.innerHTML = codes.map(code => `
        <li class="cart-chip">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" aria-hidden="true"><g stroke-linejoin="round" clip-path="url(#a)"><path stroke-linecap="round" d="M10.5 1.5H7.93a2.5 2.5 0 0 0-1.8.766L1.52 7.052a1.5 1.5 0 0 0 .02 2.101l3.48 3.48a1.25 1.25 0 0 0 1.75.016l5.116-4.926a2 2 0 0 0 .613-1.441V3.5a2 2 0 0 0-2-2"></path><circle cx="9.5" cy="4.5" r="0.563" stroke-linecap="round"></circle><path d="M9.49 4.49h.02v.02h-.02z"></path></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"></path></clipPath></defs></svg>
          <span>${escapeHtml(code)}</span>
        </li>`).join('');
    }

    const newCents = cart.total_price;
    const oldCents = newCents + cart.total_discount;

    if (totalEl) totalEl.textContent = $money(newCents);

    const origPriceEl = document.getElementById('CartOriginalPrice');
    if (origPriceEl) {
      origPriceEl.textContent = cart.total_discount > 0 ? $money(oldCents) : '';
      origPriceEl.style.display = cart.total_discount > 0 ? '' : 'none';
    }

    if (checkoutBtn) checkoutBtn.href = '/checkout';
  };

  async function handleCartUpdate(cart) {
    if (!cart) return;

    currentCart = cart; // Сохраняем для refresh
    lastKnownTotal = cart.total_price;
    const changed = await syncGifts(cart);

    if (changed) {
      const updatedCart = await getCart();
      return handleCartUpdate(updatedCart);
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return cart;
  }

  const openDrawer = async () => {
    drawer.setAttribute('aria-hidden', 'false');
    drawer.inert = false;
    document.body.style.overflow = 'hidden';
    panel.classList.add('cart-drawer__panel--updating');
    // До открытия панель скрыта и ширина трека = 0, поэтому кламп краевых вех
    // посчитать было нельзя. Теперь ширина реальная — раскладываем заново.
    layoutGifts();

    try {
      const cart = await getCart();
      await handleCartUpdate(cart);
      await renderRecos(cart);
    } catch (err) {
      console.error('Error loading cart contents:', err);
    } finally {
      panel.classList.remove('cart-drawer__panel--updating');
    }
  };

  const closeDrawer = () => {
    drawer.setAttribute('aria-hidden', 'true');
    // `inert` alongside aria-hidden. On its own, aria-hidden hides the drawer
    // from a screen reader but leaves every button inside it in the tab order,
    // so keyboard focus fell into a panel nobody could see — which is exactly
    // what Lighthouse flags as "ARIA hidden element must not be focusable".
    // inert removes the subtree from focus AND from the accessibility tree,
    // and it is the only thing that does both without touching each control.
    drawer.inert = true;
    document.body.style.overflow = '';
  };

  if (toggleBtn) {
    toggleBtn.addEventListener('click', e => {
      e.preventDefault();
      drawer.getAttribute('aria-hidden') === 'true' ? openDrawer() : closeDrawer();
    });
  }

  closeEls.forEach(btn => btn.addEventListener('click', closeDrawer));

  // The empty-state link is rendered dynamically, so close the drawer through
  // delegation before its normal navigation to the Sets anchor.
  drawer.addEventListener('click', e => {
    if (e.target.closest('.cart-empty__btn')) closeDrawer();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });

  // Обработчик кнопки refresh
  if (refreshBtn) {
    refreshBtn.addEventListener('click', async () => {
      if (isRefreshing || !currentCart) return;

      isRefreshing = true;
      await renderRecos(currentCart, true); // forceRefresh = true
      isRefreshing = false;
    });
  }

  if (itemsEl) {
    itemsEl.addEventListener('click', async e => {
      const row = e.target.closest('.cart-item');
      if (!row) return;

      const isGift = row.hasAttribute('data-gift');
      const key = row.dataset.id;
      const qtyEl = row.querySelector('.qty-val');
      const qty = qtyEl ? parseInt(qtyEl.textContent) || 1 : 1;

      if (e.target.closest('.js-plus')) {
        updateCart(key, qty + 1);
      } else if (e.target.closest('.js-minus') && qty > 1) {
        updateCart(key, qty - 1);
      } else if (e.target.closest('.js-remove')) {
        if (isGift) {
          const v_id = +row.dataset.variant;
          if (v_id && !skippedGifts.includes(v_id)) {
            skippedGifts.push(v_id);
            saveSkipped();
          }
        }
        updateCart(key, 0);
      }
    });
  }

  if (recoList) {
    recoList.addEventListener('click', async e => {
      const btn = e.target.closest('button[data-id]');
      if (!btn) return;

      btn.disabled = true;
      isCartUpdating++;
      refreshOverlay();

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: +btn.dataset.id, quantity: 1 })
        });
        if (!response.ok) throw new Error('Unable to add recommended product');

        const cart = await getCart();
        await handleCartUpdate(cart);
      } catch (err) {
        console.error('Add reco item error', err);
      } finally {
        isCartUpdating--;
        refreshOverlay();
        btn.disabled = false;
      }
    });
  }

  document.addEventListener('cart:updated', ({ detail: { cart } }) => {
    if (!cart) return;

    if (totalEl) totalEl.textContent = $money(cart.total_price);
    renderProgress(cart.total_price);
    renderItems(cart);
    renderRecos(cart);
    renderTotals(cart);
    renderCartNote(cart);

    const headerCount = document.getElementById('HeaderCartCount');
    if (headerCount) headerCount.textContent = cart.item_count;

    // Drawer title counter: "Cart (2)" when there are items, plain "Cart"
    // when empty. Uses item_count (total units) to match the header badge.
    const drawerCount = document.getElementById('CartDrawerCount');
    if (drawerCount) drawerCount.textContent = cart.item_count > 0 ? ` (${cart.item_count})` : '';
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      // Кламп краевых вех и заполнение считаются от ширины трека —
      // пересчитываем оба при resize.
      layoutGifts();
      renderProgress(lastKnownTotal);
    }, 100);
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (window.location.hash === '#cart') openDrawer();
  });
})();
